import { IHistory } from '../../../types';
export type HistoryState = IHistory;

export enum HistoryActionTypes {
  UPDATE_HISTORY_FIELD = '@@visa/history/UPDATE_HISTORY_FIELD',
}

export enum Pages {
  PAGE1 = 'uni-h-step1',
  PAGE2 = 'uni-h-step2',
  PAGE3 = 'uni-h-step3',
  PAGE4 = 'uni-h-step4',
}
